import { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import {
  IconButton,
  LinearProgress,
  Box,
  Pagination,
  Select,
  MenuItem,
} from "@mui/material";
import { ArrowUpwardIcon } from "../../icons/index.tsx";

export default function InspStatReportTable({
  rows,
  columns,
  selectedFields,
  handleHeaderClick,
  handleColumnResize,
  getColumnWidth,
  onScrollEnd,
  loading,
  setUuid,
  setOpenModal,
  setSelectedData,
  getRowId,
  page,
  setPage,
  pageSize,
  setPageSize,
  totalCount,
  siteData,
  reportField,
  setReportField,
}) {
  useEffect(() => {
    if (siteData && siteData.tableField) {
      const updatedColumns = columns.filter(
        (col) => siteData.tableField[col.field]
      );
      setReportField(updatedColumns);
    }
  }, [siteData]);

  const handleDetailClick = (params) => {
    setUuid(params.row.uuid);
    setOpenModal(true);
    setSelectedData(params.row);
  };

  return (
    <>
      <DataGrid
        rows={rows}
        columns={reportField.map((col, index) => ({
          ...col,
          width: getColumnWidth(col.field, col.width),
          resizable: index !== reportField.length - 1,
          renderHeader: (params) => (
            <div className="datagrid-head-container">
              <span>{params.colDef.headerName}</span>
              {selectedFields && selectedFields.includes(col.field) && (
                <IconButton
                  className="datagrid-sort-button"
                  onClick={() => handleHeaderClick(params.field)}
                >
                  <ArrowUpwardIcon sx={{ fontSize: "15px" }} />
                </IconButton>
              )}
            </div>
          ),
        }))}
        paginationMode="server"
        pagination
        hideFooter={true}
        onRowClick={(params) => handleDetailClick(params)}
        getRowId={getRowId}
        disableRowSelectionOnClick={false}
        disableExtendRowFullWidth
        disableColumnSelectionOnClick
        disableColumnMenu
        disableColumnSorting
        onColumnResize={handleColumnResize}
        onRowsScrollEnd={onScrollEnd}
        loading={loading}
        slots={{
          loadingOverlay: LinearProgress,
        }}
        sx={{
          border: "1px solid var(--dashboard-line-color) !important",
          height: "500px",
          "--DataGrid-rowBorderColor": "transparent",
          "--unstable_DataGrid-overlayBackground": "var(--td-color)",
          "& .MuiDataGrid-container--top [role='row'], & .MuiDataGrid-container--bottom [role='row']":
            {
              background: "var(--th-color)",
            },
          "& .MuiDataGrid-root": {
            overflowX: "auto",
            "--DataGrid-rowBorderColor": "transparent",
          },
          "& .MuiContainer-root": {
            position: "fixed",
          },
          // "& .MuiDataGrid-scrollbar--vertical": {
          //   display: "none",
          // },
          "& .MuiDataGrid-columnHeader": {
            backgroundColor: "var(--th-color)",
          },
          "& .MuiDataGrid-scrollbarFiller--header": {
            backgroundColor: "var(--th-color)",
          },
          "& .MuiDataGrid-scrollbarFiller--borderTop": {
            borderTop: "none",
          },
          "& .MuiDataGrid-scrollbarFiller": {
            display: "none",
          },
          "& .MuiDataGrid-filler": {
            backgroundColor: "var(--th-color)",
            display: "none",
          },
          "& .MuiDataGrid-row": {
            backgroundColor: "var(--row-color)",
            color: "var(--text-color)",
          },
          "& .MuiDataGrid-withBorderColor": {
            borderColor: "var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-cell": {
            borderTop: "1px solid var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-row:last-child .MuiDataGrid-cell": {
            borderBottom: "1px solid var(--dashboard-line-color)",
          },
          "& .MuiDataGrid-cell:focus": {
            outline: "none",
          },
          "& .MuiDataGrid-columnHeaderTitle": {
            color: "var(--text-color)",
          },
          "& .MuiSvgIcon-root": {
            color: "var(--text-color)",
          },
          "& .MuiDataGrid-overlayWrapper": {
            minHeight: "30vh",
          },
        }}
      />
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          mt: 1,
          color: "var(--text-color)",
        }}
      >
        <Pagination
          count={Math.ceil(totalCount / pageSize)}
          page={page}
          onChange={(event, newPage) => setPage(newPage)}
          sx={{
            "& .MuiPaginationItem-root": {
              color: "var(--text-color)", // 페이지 숫자 색상
            },
            "& .MuiPaginationItem-root:hover": {
              backgroundColor: "var(--hover-bg-color)",
            },
          }}
        />
      </Box>
    </>
  );
}
